<script lang="ts">
  import { IconLink } from '$shared/components';
  import type { VerticalNavModel } from '$shared/models/VerticalNavModel';

  interface Props {
    nav: VerticalNavModel;
    active: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { nav, active, onclick }: Props = $props();
</script>

<div class="addtional-nav">
  <IconLink icon={nav.data?.icon} name={nav.id} active={active === nav.id} {onclick}>
    {nav.label}
  </IconLink>
</div>
